<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="31" viewBox="0 0 21 31" width="21" xmlns="http://www.w3.org/2000/svg"><g :fill="color"><path d="m20.8365 12.6713c-.5349 3.0595-2.1756 5.3022-4.6527 7.0188-1.5374 1.0652-3.2229 1.8074-4.9777 2.3865-.9727.3208-1.97953.5412-2.97997.7616-2.28746.5067-4.6037.8027-6.9423.9042-.21735.0097-.410189.0195-.67761.0195v-5.649c.319627-.0065.5629-.0141.72981-.0227.62647-.0313 1.2572-.0346 1.87835-.1134 1.42979-.1815 2.85107-.3976 4.24997-.7876 1.04838-.2917 2.07545-.6212 3.06625-1.0663 1.3638-.6125 2.6306-1.3752 3.6502-2.5052.9461-1.0479 1.4692-2.2536 1.222-3.69364-.4038-2.34538-2.0989-4.07713-4.5088-4.25214-1.55769-.11343-2.87882.36299-3.97301 1.49948-.72769.75623-1.11444 1.68098-1.33285 2.69108-.04368.20422-.06924.41272-.10121.65362h-5.48693c.00319627-.1059.0010597-.202.00745224-.2939.05220576-.72811.15236376-1.46057.32815876-2.16494.294057-1.17754.768159-2.28811 1.457489-3.29497 1.13894-1.66261 2.5762-2.95791 4.40873-3.808124 1.94972-.9042272 3.98577-1.144058 6.07187-.81132 1.8048.287365 3.4456 1.000374 4.8722 2.215734 1.4947 1.2737 2.5751 2.82828 3.2058 4.68102.6212 1.82466.8247 3.6871.4848 5.6306z"/><path d="m20.6042 25.3435h-19.99798v5.6565h19.99798z"/></g></svg>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/2.vue